import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=1b3f5acb&scoped=true&"
import script from "./SidebarHeader.vue?vue&type=script&lang=js&"
export * from "./SidebarHeader.vue?vue&type=script&lang=js&"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=1b3f5acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f5acb",
  null
  
)

export default component.exports